define('modules/pop-over',['jquery', 'utils/is-fixed', 'utils/fit-screen-vertically', 'settings'], function (
  $,
  isPosFixed,
  FitScreenVertically,
  settings
) {
  return (function () {
    var popOverHtml =
      '<div class="pop-over">' +
      '<div class="col-container col-container--padded">' +
      '<span class="pop-over__pointer"></span>' +
      '<div class="pop-over__content-box">' +
      '<div class="pop-over__scroll-box">' +
      '</div>' +
      '<div class="pop-over__loader">' +
      '<span class="pop-over__loader__icon"></span>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>';

    /**
     * @class PopOver
     * @param sourceEl
     * @param content
     * @param {Boolean} scrollable Determine if the popover should be scrollable in itself
     * @constructor
     */
    function PopOver(sourceEl, content, scrollable) {
      this.scrollable = scrollable;
      this.sourceEl = sourceEl;
      this.uniqueID = Math.floor(Math.random() * 100000);

      if (typeof content === 'object') {
        this.content = content.html();
        this._insertIntoDom();
      } else if (typeof content === 'string') {
        var _this = this;

        $.get(content, function (data) {
          _this.content = data;
          _this._insertIntoDom();
        });
      }
    }

    /**
     * Listen to an event to open/show the pop-over
     *
     * @method openOn
     * @param {String} eventName
     */
    PopOver.prototype.openOn = function (eventName) {
      var _this = this;

      this.sourceEl.on(eventName + '.open-popover', function (event) {
        event.preventDefault();

        if (!_this.visible) {
          _this.show($(this));
        }
      });
    };

    /**
     * Turn off listening to an event to open/show the pop-over
     *
     * @method openOff
     * @param {String} eventName
     */
    PopOver.prototype.openOff = function (eventName) {
      this.sourceEl.off(eventName + '.open-popover');
    };

    /**
     * Shows the pop-over
     *
     * @param {jQuery} triggerEl
     * @method show
     */
    PopOver.prototype.show = function (triggerEl, closeCb) {
      var _this = this;
      this.el.show();
      this._setPosition(triggerEl);
      this.el.addClass('pop-over--visible');
      this.visible = true;

      setTimeout(function () {
        _this._initCloseOnOutsideClick(closeCb);
      }, 0);

      this._enableFitScreen();
    };

    /**
     * Hides the pop-over
     *
     * @method hide
     */
    PopOver.prototype.hide = function (cb) {
      if (cb) {
        this.hideCb = cb;
      }

      var _this = this;

      $('html').off('click.popOverOutside touchend.popOverOutside');
      this.el.removeClass('pop-over--visible');

      this.visible = false;

      setTimeout(function () {
        _this.el.hide();
      }, settings.transitionTime);

      this.unbindScrollListeners();

      this._disableFitScreen();

      if (this.hideCb) {
        this.hideCb();
      }
    };

    /**
     * Shows overlay loader
     *
     * @method showLoader
     */
    PopOver.prototype.showLoader = function () {
      $('.pop-over__loader', this.el).addClass('pop-over__loader--visible');
    };

    /**
     * Hide overlay loader
     *
     * @method hideLoader
     */
    PopOver.prototype.hideLoader = function () {
      $('.pop-over__loader', this.el).removeClass('pop-over__loader--visible');
    };

    /**
     * @method toggleScrollHiders
     * @param active
     */
    PopOver.prototype.toggleScrollHiders = function (active) {
      this.scrollHiders = active;
    };

    /**
     * Sets up a click-listener which will dismiss/hide the pop over
     * when the user clicks anywhere outside of it
     *
     * @method _initCloseOnOutsideClick
     * @private
     */
    PopOver.prototype._initCloseOnOutsideClick = function (closeCb) {
      var _this = this;

      $('html').on('click.popOverOutside touchend.popOverOutside', function (event) {
        if (_this.visible) {
          if (!$(event.target).closest(_this.el).length && !$(event.target).closest('.header-cart-product').length) {
            _this.hide(closeCb);
          }
        }
      });
    };

    /**
     * Inserts the pop-over markup into the DOM for quick
     * access later
     *
     * @method _insertIntoDom
     * @private
     */
    PopOver.prototype._insertIntoDom = function () {
      this.el = $(popOverHtml).appendTo('body');
      this.el.find('.pop-over__scroll-box').html(this.content);
    };

    /**
     * Sets all of the pop over positions, including
     * both the content box and the pointer
     *
     * @param {jQuery} triggerEl
     * @method _setPosition
     * @private
     */
    PopOver.prototype._setPosition = function (triggerEl) {
      var horizontalPos = this._getHorizontalPosition(triggerEl),
        isFixed = isPosFixed(triggerEl);

      if (isFixed) {
        this.el.css('position', 'fixed');
        this._hideIfNoLongerFixedAfterScroll(triggerEl);
      } else {
        this.el.css('position', 'absolute');
        this._hideIfNoLongerFitScreenAfterScroll();
      }

      this.el.css('top', this._getVerticalPosition(triggerEl, isFixed));
      this.el.find('.pop-over__content-box').css(horizontalPos.from, horizontalPos.elOffset);
      this.el.find('.pop-over__pointer').css(horizontalPos.from, horizontalPos.pointerOffset);
    };

    /**
     * Calculate the appropriate vertical position
     *
     * @param {jQuery} triggerEl
     * @param {Boolean} fixed This argument is optional
     * @method _getVerticalPosition
     * @returns {*}
     * @private
     */
    PopOver.prototype._getVerticalPosition = function (triggerEl, fixed) {
      if (fixed === undefined) {
        fixed = false;
      }

      var top = triggerEl.offset().top;

      if (fixed) {
        top = top - $(document).scrollTop();
      }

      return top + triggerEl.outerHeight();
    };

    /**
     * Calculate the appropriate horizontal offset and offset
     * direction for both the actual content box and pointer
     *
     * @param {jQuery} triggerEl
     * @method _getHorizontalPosition
     * @returns {{from: *, elOffset: *, pointerOffset: *}}
     * @private
     */
    PopOver.prototype._getHorizontalPosition = function (triggerEl) {
      var container = this.el.find('.col-container'),
        leftOffset = triggerEl.offset().left + triggerEl.outerWidth() / 2,
        elWidth = this.el.find('.pop-over__content-box').width(),
        pointerWidth = this.el.find('.pop-over__pointer').width(),
        pointerDiagonal = this._squareDiagonalLength(pointerWidth),
        containerWidth = container.outerWidth(),
        containerLeftOffset = container.offset().left,
        leftOffsetFromContainer = leftOffset - containerLeftOffset,
        from,
        elOffset,
        pointerOffset;

      if (leftOffsetFromContainer > containerWidth / 2) {
        from = 'right';
        elOffset = containerWidth - leftOffsetFromContainer - elWidth / 2;
        pointerOffset = containerWidth - leftOffsetFromContainer - pointerDiagonal / 2;
      } else {
        from = 'left';
        elOffset = leftOffsetFromContainer - elWidth / 2;
        pointerOffset = leftOffsetFromContainer - pointerDiagonal / 2;
      }

      return {
        from: from,
        elOffset: elOffset > 10 ? elOffset : 10,
        pointerOffset: pointerOffset > 10 ? pointerOffset : 10
      };
    };

    /**
     * Calculates a squares diagonal length using pythagoras
     * theorem (a^2 + b^2 = c^2)
     *
     * @method _squareDiagonalLength
     * @param {Number} side
     * @return {Number} Rounded number
     * @private
     */
    PopOver.prototype._squareDiagonalLength = function (side) {
      var diagonalSquare = Math.pow(side, 2) * 2,
        diagonal = Math.sqrt(diagonalSquare);

      // Round the output
      return Math.round(diagonal);
    };

    /**
     * Will hide the pop over if the triggering element loses
     * it's fixed state due to scroll
     *
     * @method _hideIfNoLongerFixedAfterScroll
     * @param el
     * @private
     */
    PopOver.prototype._hideIfNoLongerFixedAfterScroll = function (el) {
      var _this = this;

      $(window).on('scroll.fixedCheck' + _this.uniqueID, function () {
        if (!isPosFixed(el)) {
          $(window).off('scroll.fixedCheck' + _this.uniqueID);
          if (_this.scrollHiders !== false) {
            _this.hide();
          }
        }
      });
    };

    /**
     * Will hide the pop over if the top is cropped after scroll.
     *
     * @method _hideIfNoLongerFitScreenAfterScroll
     * @private
     */
    PopOver.prototype._hideIfNoLongerFitScreenAfterScroll = function () {
      var _this = this,
        $window = $(window);

      $window.on('scroll.noLongerFitScreen' + _this.uniqueID, function () {
        if ($window.scrollTop() > _this.el.offset().top) {
          $window.off('scroll.noLongerFitScreen' + _this.uniqueID);
          if (_this.scrollHiders !== false) {
            _this.hide();
          }
        }
      });
    };

    /**
     * Unbind all scroll listeners after hiding the popup
     * @method unbindScrollListeners
     */
    PopOver.prototype.unbindScrollListeners = function () {
      $(window)
        .off('scroll.noLongerFitScreen' + this.uniqueID)
        .off('scroll.fixedCheck' + this.uniqueID);
    };

    /**
     * Enables current popup fit the screen
     *
     * @method _enableFitScreen
     * @private
     */
    PopOver.prototype._enableFitScreen = function () {
      var _this = this;
      this._disableFitScreen();

      window.setTimeout(function () {
        _this._fsv = new FitScreenVertically(_this.el.find('.pop-over__scroll-box'), _this.scrollable);
        _this._fsv.enable();
      }, settings.transitionTime);
    };

    /**
     * Need to be executed after DOM change inside popover
     *
     * @method resetHeight
     */
    PopOver.prototype.resetHeight = function () {
      if (this._fsv) {
        this._fsv.reset();
      }
    };

    /**
     * Turn off scroll listeners and resize listeners.
     * Does not limit the height of the content box
     *
     * @method _enableFitScreen
     * @private
     */
    PopOver.prototype._disableFitScreen = function () {
      if (this._fsv) {
        this._fsv.disable();
      }
    };

    return PopOver;
  })();
});

